/**
 * TtfCmapTable.ts class for EJ2-PDF
 */
var TtfCmapTable = /** @class */ (function () {
    function TtfCmapTable() {
    }
    return TtfCmapTable;
}());
export { TtfCmapTable };
